<script>
	import { browser } from '$app/environment';
	// import WhatsAppIcon from '$lib/components/icons/WhatsAppIcon.svelte';
	import { isMobileOrTablet } from '$lib/components/common/Device';
	import { onMount } from 'svelte';
	import { get } from 'svelte/store';

	export let url;
	export let title;

	let baseUrl;
	let urlWithParameters;

	onMount(() => {
		const currentDevice = get(isMobileOrTablet);
		baseUrl =
			browser && currentDevice ? 'https://api.whatsapp.com/send' : 'https://web.whatsapp.com/send';

		const parametersObject = {
			text: title ? title + ' ' + url : url
		};

		const params = Object.entries(parametersObject)
			.filter(([, value]) => value ?? false)
			.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
			.join('&');

		urlWithParameters = params === '' ? baseUrl : `${baseUrl}?${params}`;
	});

	function handleClick() {
		const config = {
			height: 550,
			width: 400,
			location: 'no',
			toolbar: 'no',
			status: 'no',
			directories: 'no',
			menubar: 'no',
			scrollbars: 'yes',
			resizable: 'no',
			centerscreen: 'yes',
			chrome: 'yes'
		};
		return window.open(
			urlWithParameters,
			'',
			Object.keys(config)
				.map((key) => `${key}=${config[key]}`)
				.join(',')
		);
	}
</script>

<button class="border-none" on:click={handleClick}>
	<span class="screen-reader-text"></span>
	Share on WhatsApp
</button>
